<template>
  <div class="tech-board-item-container">
    <div class="header">
      <router-link
        v-if="link"
        :to="link"
      >
        {{ header }}
      </router-link>
      <span v-else>
        {{ header }}
      </span>
    </div>
    <div class="body">
      {{ getNumberLocale(number) }}
    </div>
    <img
      v-if="change === 'up'"
      src="@shared/assets/img/adoption/up.png"
      alt="Change Indicator"
      class="change-icon"
    >
    <img
      v-else-if="change === 'down'"
      src="@shared/assets/img/adoption/down.png"
      alt="Change Indicator"
      class="change-icon"
    >
  </div>
</template>

<script>
import formatterMixin from '@shared/mixins/formatterMixin';

export default {
  name: 'BoardItem',
  mixins: [formatterMixin],
  props: {
    header: String,
    number: Number,
    change: String,
    link: String,
  },
};
</script>

<style lang="scss">

.tech-board-item-container {
  width: 100%;
  gap: 16px;
  background-color: $N90;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  padding: 12px 8px;

  &:not(:last-child) {
    margin-bottom: 8px;
  }

  .header {
    flex: 1;
    color: $WHITE;
    line-height: 1;
    font-weight: 600;

    a {
      color: $WHITE;
      text-decoration: underline;
    }
  }

  .body {
    color: $WHITE;
    font-weight: 500;
    line-height: 1;
  }

  .change-icon {
    width: 10px;
    height: 6px;
    object-fit: contain;
    margin-left: 8px;
  }
}
</style>
